class ToggleElement {
  constructor(element) {
    this.element = element
    this.target = element.getAttribute('data-target')
    this.classes = element.getAttribute('data-classes')
    this.siblingsClass = element.getAttribute('data-siblings')
    this.siblings = [...document.querySelectorAll(this.siblingsClass)]
    this.delayedClasses = element.getAttribute('data-delayed-classes')
    this.closingOutsideClick = element.hasAttribute('data-closing-outside-click')
    this.isExpanded = false

    this.targetDomEl = document.querySelector(this.target) ?? element

    if (!this.element.hasAttribute('aria-expanded')) {
      this.element.setAttribute('aria-expanded', 'false')
    }


    if (this.siblings.length === 0) {
      this.siblings = [this.element]
    }

    this.element.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      this.toggle()

    }, false)

    if (this.closingOutsideClick && this.targetDomEl) {
      document.body.addEventListener('click', (event) => {
        if (!this.isExpanded) { return }
        if (this.targetDomEl.contains(event.target)) { return }

        this.toggle()

      }, false)
    }

  }

  toggle() {
    const oldStatus = (this.element.getAttribute('aria-expanded') === 'true')
    this.isExpanded = !oldStatus

    this.siblings.forEach(item => {
      if (item == this.targetDomEl || this.isExpanded) {
        item.setAttribute('aria-expanded', 'true')
      } else {
        item.setAttribute('aria-expanded', 'false')
      }
    })


    //for animaiton and visible in css
    if (this.delayedClasses) {
      if (!this.isExpanded) {
        setTimeout(() => {
          this.targetDomEl.classList.remove(this.delayedClasses)
        }, 300);
      } else {
        this.targetDomEl.classList.add(this.delayedClasses)
      }
    }
    if (this.classes) {
      this.targetDomEl.classList.toggle(this.classes)
    }
  }

}

export default ToggleElement